import L from 'leaflet';
import { MarkerType } from "../../store";
import { markerSvgMarkup } from './Icon';

export function LeafletIcon(
  { marker, number="1", letter="A", width, height, className="", scale=1 }:
  { marker: MarkerType, number: string, letter: string, width: number, height: number, className?: string, scale?: number })
{
  const iconSize = [width * scale, height * scale] as [number, number];
  const iconAnchor = [width * scale / 2, height * scale] as [number, number];
  const popupAnchor = [0, height * scale * -0.70] as [number, number];

  // Show created icons as SVG
  if (marker.state) {
    // TODO: Other CSS could affect the icons
    // SVG icons with dynamic text (space number / letter)
    const svgString = markerSvgMarkup(marker, number, letter);
    return (
      L.divIcon({
        html: svgString,
        iconSize,
        iconAnchor,
        popupAnchor,
        className,
      })
    );
  }

  return (
    L.icon({
      iconUrl: marker.base64 || marker.url,
      iconSize,
      iconAnchor,
      popupAnchor,
      className,
    })
  );
}
